<!-- start banner Area -->
<section class="top-banner mb-4">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="padding: 30px 0px 0px 0px !important;"> Editer la Formation </h1>
                    <p class="text-white link-nav"><a [routerLink]="['/accueil', 'candidat']"
                            style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
                        <span> éditer formation</span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- End banner Area -->

<section class="service-area section-gap" id="service">
    <div class="container mb-5">

        <section class="row justify-content-center">
            <!-- Button to go back apply job -->
            <div class="col-md-4" *ngIf="showBtnToGoApplyJob">
                <a routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-warning">Retour vers la page d'emploi</a>
            </div>
        </section>
        <section class="row justify-content-center">
            <div class="col-lg-10 ">
                <fieldset class="form-area fieldset-panel">
                    <legend class="legend-style" style="width: 55%;">Mettre à jour les informations de la formation
                    </legend>
                    <form [formGroup]="trainingsForm" (ngSubmit)="onSubmitTrainingForm()">
                        <input type="text" class="form-control h-40px text-uppercase" id="candidate_training_id"
                            formControlName="candidate_training_id" hidden>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="training">Formation <span class="star-style">**</span></label>
                                <select class="form-control h-40px" id="training" formControlName="training_id">
                                    <option value="" selected>Selectionner...</option>
                                    <option [value]="training.getId()" *ngFor="let training of trainingList">{{
                                        training.getLibelle() }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="level_of_study">Diplôme <span class="star-style">**</span></label>
                                <select class="form-control" id="level_of_study" formControlName="level_of_study">
                                    <option value="">Selectionner...</option>
                                    <option value="Secondaire">Secondaire</option>
                                    <option value="Terminal">Terminal</option>
                                    <option value="Formation professionnelle">Formation professionnelle</option>
                                    <option value="Baccalauréat">Baccalauréat</option>
                                    <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                                    <option value="BAC + 2">BAC + 2</option>
                                    <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                                    <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                                    <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                                    <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="university">Université <span class="star-style">**</span></label>
                                <input type="text" class="form-control h-40px text-uppercase" id="university"
                                    formControlName="university">
                            </div>

                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="periodStartTraining">Date début <span class="star-style">**</span></label>
                                <select class="form-control" id="periodStartTraining" formControlName="month_start">
                                    <option value="">Selectionner...</option>
                                    <option value="01">Janvier</option>
                                    <option value="02">Février</option>
                                    <option value="03">Mars</option>
                                    <option value="04">Avril</option>
                                    <option value="05">Mai</option>
                                    <option value="06">Juin</option>
                                    <option value="07">Juillet</option>
                                    <option value="08">Aôut</option>
                                    <option value="09">Septembre</option>
                                    <option value="10">Octobre</option>
                                    <option value="11">Novembre</option>
                                    <option value="12">Décembre</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="periodStartTraining">Année <span class="star-style">**</span></label>
                                <!-- <input type="number" step="1" min="1900" class="form-control h-40px" > -->
                                <select class="form-control" id="year" formControlName="year_start">
                                    <option value="1984">1984</option>
                                    <option value="1985">1985</option>
                                    <option value="1986">1986</option>
                                    <option value="1987">1987</option>
                                    <option value="1988">1988</option>
                                    <option value="1989">1989</option>
                                    <option value="1990">1990</option>
                                    <option value="1991">1991</option>
                                    <option value="1992">1992</option>
                                    <option value="1993">1993</option>
                                    <option value="1994">1994</option>
                                    <option value="1995">1995</option>
                                    <option value="1996">1996</option>
                                    <option value="1997">1997</option>
                                    <option value="1998">1998</option>
                                    <option value="1999">1999</option>
                                    <option value="2000">2000</option>
                                    <option value="2001">2001</option>
                                    <option value="2002">2002</option>
                                    <option value="2003">2003</option>
                                    <option value="2004">2004</option>
                                    <option value="2005">2005</option>
                                    <option value="2006">2006</option>
                                    <option value="2007">2007</option>
                                    <option value="2008">2008</option>
                                    <option value="2009">2009</option>
                                    <option value="2010">2010</option>
                                    <option value="2011">2011</option>
                                    <option value="2012">2012</option>
                                    <option value="2013">2013</option>
                                    <option value="2014">2014</option>
                                    <option value="2015">2015</option>
                                    <option value="2016">2016</option>
                                    <option value="2017">2017</option>
                                    <option value="2018">2018</option>
                                    <option value="2019">2019</option>
                                    <option value="2020">2020</option>
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4 my-auto">
                                <input type="checkbox" id="trainingInProgress"
                                    (click)="functionsService.showOrHideEndDate('blockPeriodEndTraining', 'trainingInProgress', true)">
                                <label for="trainingInProgress" style="margin-left: 5px"
                                    (click)="functionsService.showOrHideEndDate('blockPeriodEndTraining', 'trainingInProgress', false)">En
                                    cours</label>
                            </div>
                        </div>
                        <div id="blockPeriodEndTraining">
                            <div class="row">
                                <div class="form-group col-md-4" id="blockPeriodEndTraining">
                                    <label for="periodEndTraining">Date Fin</label>
                                    <select class="form-control" id="periodEndTraining" formControlName="month_end">
                                        <option value="">Selectionner...</option>
                                        <option value="01">Janvier</option>
                                        <option value="02">Février</option>
                                        <option value="03">Mars</option>
                                        <option value="04">Avril</option>
                                        <option value="05">Mai</option>
                                        <option value="06">Juin</option>
                                        <option value="07">Juillet</option>
                                        <option value="08">Aôut</option>
                                        <option value="09">Septembre</option>
                                        <option value="10">Octobre</option>
                                        <option value="11">Novembre</option>
                                        <option value="12">Décembre</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="periodEndTraining">Année</label>
                                    <!-- <input type="number" step="1" min="1900" id="periodEndTraining"
                                    class="form-control h-40px" formControlName="year_end"> -->
                                    <select class="form-control" id="year" formControlName="year_end">

                                        <option value="1984">1984</option>
                                        <option value="1985">1985</option>
                                        <option value="1986">1986</option>
                                        <option value="1987">1987</option>
                                        <option value="1988">1988</option>
                                        <option value="1989">1989</option>
                                        <option value="1990">1990</option>
                                        <option value="1991">1991</option>
                                        <option value="1992">1992</option>
                                        <option value="1993">1993</option>
                                        <option value="1994">1994</option>
                                        <option value="1995">1995</option>
                                        <option value="1996">1996</option>
                                        <option value="1997">1997</option>
                                        <option value="1998">1998</option>
                                        <option value="1999">1999</option>
                                        <option value="2000">2000</option>
                                        <option value="2001">2001</option>
                                        <option value="2002">2002</option>
                                        <option value="2003">2003</option>
                                        <option value="2004">2004</option>
                                        <option value="2005">2005</option>
                                        <option value="2006">2006</option>
                                        <option value="2007">2007</option>
                                        <option value="2008">2008</option>
                                        <option value="2009">2009</option>
                                        <option value="2010">2010</option>
                                        <option value="2011">2011</option>
                                        <option value="2012">2012</option>
                                        <option value="2013">2013</option>
                                        <option value="2014">2014</option>
                                        <option value="2015">2015</option>
                                        <option value="2016">2016</option>
                                        <option value="2017">2017</option>
                                        <option value="2018">2018</option>
                                        <option value="2019">2019</option>
                                        <option value="2020">2020</option>
                                        <option value="2021">2021</option>
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="diploma">Attestation <span style="font-size: 10px; font-weight: 700;">(pdf,
                                        < 1Mo)</span>
                                </label>
                                <span class="form-control h-40px btn btn-success" (click)="chooseDiploma()">Joindre
                                    fichier</span><span *ngIf="diplomaFile != null"
                                    style="font-size: 10px; font-weight: 700; color: green">
                                    Super! Fichier
                                    joint</span>
                            </div>
                        </div>
                        <button type="submit" class="primary-btn text-white" [disabled]="trainingsForm.invalid"
                            *ngIf="!trainingIsLoading">Ajouter</button>
                        <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="trainingIsLoading">
                            Veuillez
                            patienter...
                        </p>
                    </form>
                </fieldset>
                <div class="row justify-content-center mt-5">

                    <a routerLink="/postuler/{{ jobIDToApply }}" class="btn btn-warning mr-2">Retour vers la page
                        d'emploi</a>

                    <button class="btn btn-outline-warning col-md-2 mr-2" routerLink="/candidat-infos">Retour
                    </button>
                    <button class="btn btn-primary col-md-6" routerLink="/candidat-certificates"> Cliquez ici pour
                        ajouter
                        vos certificats
                    </button>
                </div>
            </div>
        </section>

    </div>
</section>